module.exports = __webpack_public_path__ + "img/border-vychytavky.b11d53b.png";